export default "__VITE_ASSET__CiNccJWU__"